import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=63cdb00d&scoped=true"
import script from "./SaleScript.js?vue&type=script&lang=js&external"
export * from "./SaleScript.js?vue&type=script&lang=js&external"
import style0 from "./Sales.vue?vue&type=style&index=0&id=63cdb00d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cdb00d",
  null
  
)

export default component.exports